import { action } from 'typesafe-actions';

// Types
import {
  SchedulesMatrixTypes,
  SchedulesMatrixInterface,
  SchedulesMatrixConfigInterface,
  TripScheduleInterface,
} from './types';

// List Schedules Matrix
export const listSchedulesMatrixRequest = (payload: object) =>
  action(SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_REQUEST, payload);

export const listSchedulesMatrixSuccess = (payload: {
  schedulesMatrixList: SchedulesMatrixInterface[];
  totalCount: number;
}) => action(SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_SUCCESS, payload);

export const listSchedulesMatrixFailure = () =>
  action(SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_FAILURE);

// Get Schedules Matrix
export const getSchedulesMatrixRequest = (payload: object) =>
  action(SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_REQUEST, payload);

export const getSchedulesMatrixSuccess = (payload: {
  schedulesMatrixData: SchedulesMatrixInterface;
}) => action(SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_SUCCESS, payload);

export const getSchedulesMatrixFailure = () =>
  action(SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_FAILURE);

// Create Schedules Matrix
export const createSchedulesMatrixRequest = (payload: object) =>
  action(SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_REQUEST, payload);

export const createSchedulesMatrixSuccess = (payload: {
  schedulesMatrixData: SchedulesMatrixInterface;
}) => action(SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_SUCCESS, payload);

export const createSchedulesMatrixFailure = () =>
  action(SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_FAILURE);

// Update Schedules Matrix
export const updateSchedulesMatrixRequest = (payload: object) =>
  action(SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_REQUEST, payload);

export const updateSchedulesMatrixSuccess = (payload: {
  schedulesMatrixData: SchedulesMatrixInterface;
}) => action(SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_SUCCESS, payload);

export const updateSchedulesMatrixFailure = () =>
  action(SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_FAILURE);

// Delete Schedules Matrix
export const deleteSchedulesMatrixRequest = (payload: object) =>
  action(SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_REQUEST, payload);

export const deleteSchedulesMatrixSuccess = () =>
  action(SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_SUCCESS);

export const deleteSchedulesMatrixFailure = () =>
  action(SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_FAILURE);

// List Schedules Matrix Config
export const listSchedulesMatrixConfigRequest = (payload: object) =>
  action(SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_CONFIG_REQUEST, payload);

export const listSchedulesMatrixConfigSuccess = (payload: {
  schedulesMatrixConfigList: SchedulesMatrixInterface[];
  totalCount: number;
}) =>
  action(SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_CONFIG_SUCCESS, payload);

export const listSchedulesMatrixConfigFailure = () =>
  action(SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_CONFIG_FAILURE);

// Get Schedules Matrix Config
export const getSchedulesMatrixConfigRequest = (payload: object) =>
  action(SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_CONFIG_REQUEST, payload);

export const getSchedulesMatrixConfigSuccess = (payload: {
  schedulesMatrixConfigData: SchedulesMatrixConfigInterface;
}) => action(SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_CONFIG_SUCCESS, payload);

export const getSchedulesMatrixConfigFailure = () =>
  action(SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_CONFIG_FAILURE);

// Create Schedules Matrix Config
export const createSchedulesMatrixConfigRequest = (payload: object) =>
  action(SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_CONFIG_REQUEST, payload);

export const createSchedulesMatrixConfigSuccess = (payload: {
  schedulesMatrixConfigData: SchedulesMatrixConfigInterface;
}) =>
  action(SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_CONFIG_SUCCESS, payload);

export const createSchedulesMatrixConfigFailure = () =>
  action(SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_CONFIG_FAILURE);

// Update Schedules Matrix Config
export const updateSchedulesMatrixConfigRequest = (payload: object) =>
  action(SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_CONFIG_REQUEST, payload);

export const updateSchedulesMatrixConfigSuccess = (payload: {
  schedulesMatrixConfigData: SchedulesMatrixConfigInterface;
}) =>
  action(SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_CONFIG_SUCCESS, payload);

export const updateSchedulesMatrixConfigFailure = () =>
  action(SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_CONFIG_FAILURE);

// Delete Schedules Matrix Config
export const deleteSchedulesMatrixConfigRequest = (payload: object) =>
  action(SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_CONFIG_REQUEST, payload);

export const deleteSchedulesMatrixConfigSuccess = () =>
  action(SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_CONFIG_SUCCESS);

export const deleteSchedulesMatrixConfigFailure = () =>
  action(SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_CONFIG_FAILURE);

// List Trip Schedules
export const listTripSchedulesRequest = (payload: {
  doNotShowloading?: boolean;
  body: object;
}) => action(SchedulesMatrixTypes.LIST_TRIP_SCHEDULES_REQUEST, payload);

export const listTripSchedulesSuccess = (payload: {
  tripSchedulesList: TripScheduleInterface[];
  totalCount: number;
}) => action(SchedulesMatrixTypes.LIST_TRIP_SCHEDULES_SUCCESS, payload);

export const listTripSchedulesFailure = () =>
  action(SchedulesMatrixTypes.LIST_TRIP_SCHEDULES_FAILURE);

// Get Trip Schedules
export const getTripSchedulesRequest = (payload: object) =>
  action(SchedulesMatrixTypes.GET_TRIP_SCHEDULES_REQUEST, payload);

export const getTripSchedulesSuccess = (payload: {
  tripSchedulesData: TripScheduleInterface;
}) => action(SchedulesMatrixTypes.GET_TRIP_SCHEDULES_SUCCESS, payload);

export const getTripSchedulesFailure = () =>
  action(SchedulesMatrixTypes.GET_TRIP_SCHEDULES_FAILURE);

// Create Trip Schedules
export const createTripSchedulesRequest = (payload: object) =>
  action(SchedulesMatrixTypes.CREATE_TRIP_SCHEDULES_REQUEST, payload);

export const createTripSchedulesSuccess = (payload: {
  tripSchedulesData: TripScheduleInterface;
}) => action(SchedulesMatrixTypes.CREATE_TRIP_SCHEDULES_SUCCESS, payload);

export const createTripSchedulesFailure = () =>
  action(SchedulesMatrixTypes.CREATE_TRIP_SCHEDULES_FAILURE);

// Update Trip Schedules
export const updateTripSchedulesRequest = (payload: object) =>
  action(SchedulesMatrixTypes.UPDATE_TRIP_SCHEDULES_REQUEST, payload);

export const updateTripSchedulesSuccess = (payload: {
  tripSchedulesData: TripScheduleInterface;
}) => action(SchedulesMatrixTypes.UPDATE_TRIP_SCHEDULES_SUCCESS, payload);

export const updateTripSchedulesFailure = () =>
  action(SchedulesMatrixTypes.UPDATE_TRIP_SCHEDULES_FAILURE);

// Delete Trip Schedules
export const deleteTripSchedulesRequest = (payload: object) =>
  action(SchedulesMatrixTypes.DELETE_TRIP_SCHEDULES_REQUEST, payload);

export const deleteTripSchedulesSuccess = () =>
  action(SchedulesMatrixTypes.DELETE_TRIP_SCHEDULES_SUCCESS);

export const deleteTripSchedulesFailure = () =>
  action(SchedulesMatrixTypes.DELETE_TRIP_SCHEDULES_FAILURE);

// Update TripSchedule Info
export const tripScheduleInfoRequest = (payload: object) =>
  action(SchedulesMatrixTypes.TRIP_SCHEDULES_INFO_REQUEST, payload);

export const tripScheduleInfoSuccess = (payload: object) =>
  action(SchedulesMatrixTypes.TRIP_SCHEDULES_INFO_SUCCESS, payload);

export const tripScheduleInfoFailure = () =>
  action(SchedulesMatrixTypes.TRIP_SCHEDULES_INFO_FAILURE);

// Update Trip Schedule Profile Resevations
export const tripScheduleProfileResevationsRequest = (payload: {
  body: object;
  editMatrixId: string;
  selectedDate: Date | null | undefined;
}) =>
  action(
    SchedulesMatrixTypes.TRIP_SCHEDULES_PROFILE_RESEVATIONS_REQUEST,
    payload,
  );

export const tripScheduleProfileResevationsSuccess = (payload: object) =>
  action(
    SchedulesMatrixTypes.TRIP_SCHEDULES_PROFILE_RESEVATIONS_SUCCESS,
    payload,
  );

export const tripScheduleProfileResevationsFailure = () =>
  action(SchedulesMatrixTypes.TRIP_SCHEDULES_PROFILE_RESEVATIONS_FAILURE);
